import axios from "axios";
import {useQuery} from "react-query";
import transformHTMLToRaw from "Utils/transformHTMLToRaw";

const getTenant = async ({ identifier, branch }) => {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin/tenants/${identifier}?branch=${branch}`
    );
    return response?.data?.result;
};

export default function useTenant(tenant, options){
    return useQuery(
        "USE_TENANT",
        () => getTenant(tenant),
        options
    );
}
